export const GET_PAYMENTS_LIST = "get_terminal_payments_list";